import * as Types from '../../../generated/webapp_gql';

import { gql } from 'graphql.macro';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
const defaultOptions =  {}
export type ManageCareTeamScreenQueryVariables = Types.Exact<{
  platform?: Types.Maybe<Types.ContentCollectionPlatform>;
}>;


export type ManageCareTeamScreenQuery = (
  { __typename?: 'Query' }
  & { manageCareTeamScreen?: Types.Maybe<(
    { __typename?: 'ManageCareTeamScreenNode' }
    & Pick<Types.ManageCareTeamScreenNode, 'id' | 'name' | 'slug' | 'platform'>
    & { screenSections: Array<(
      { __typename?: 'ScreenSectionNode' }
      & Pick<Types.ScreenSectionNode, 'id' | 'uuid' | 'title' | 'subtitle' | 'renderComponent'>
      & { contentCollectionLinks: Array<{ __typename?: 'AssessmentLinkNode' } | { __typename?: 'CircleSeriesLinkNode' } | { __typename?: 'CircleSessionLinkNode' } | { __typename?: 'CircleTopicLinkNode' } | { __typename?: 'CourseLinkNode' } | { __typename?: 'ExternalLinkNode' } | { __typename?: 'HREventLinkNode' } | { __typename?: 'HRResourceLinkNode' } | (
        { __typename?: 'InternalLinkNode' }
        & Pick<Types.InternalLinkNode, 'uuid' | 'title' | 'titleTranslationKey' | 'image' | 'images' | 'subtitle' | 'colorScheme' | 'buttonText' | 'path' | 'groupKey' | 'providerInitials'>
        & { childLinks?: Types.Maybe<Array<Types.Maybe<(
          { __typename?: 'InternalLinkNode' }
          & Pick<Types.InternalLinkNode, 'uuid' | 'title' | 'titleTranslationKey' | 'image' | 'path' | 'colorScheme' | 'backgroundImage' | 'disabled' | 'additionalInformation' | 'additionalInformationTitle'>
        )>>> }
      ) | { __typename?: 'MeditationLinkNode' } | { __typename?: 'ProgramLinkNode' } | { __typename?: 'ScreenLinkNode' }> }
    )> }
  )> }
);


export const ManageCareTeamScreenDocument = gql`
    query manageCareTeamScreen($platform: ContentCollectionPlatform) {
  manageCareTeamScreen(platform: $platform) {
    id
    name
    slug
    platform
    screenSections {
      id
      uuid
      title
      subtitle
      renderComponent
      contentCollectionLinks {
        ... on InternalLinkNode {
          uuid
          title
          titleTranslationKey
          image
          images
          subtitle
          colorScheme
          buttonText
          path
          groupKey
          providerInitials
          childLinks {
            ... on InternalLinkNode {
              uuid
              title
              titleTranslationKey
              image
              path
              colorScheme
              backgroundImage
              disabled
              additionalInformation
              additionalInformationTitle
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useManageCareTeamScreenQuery__
 *
 * To run a query within a React component, call `useManageCareTeamScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageCareTeamScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageCareTeamScreenQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useManageCareTeamScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ManageCareTeamScreenQuery, ManageCareTeamScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ManageCareTeamScreenQuery, ManageCareTeamScreenQueryVariables>(ManageCareTeamScreenDocument, options);
      }
export function useManageCareTeamScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ManageCareTeamScreenQuery, ManageCareTeamScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ManageCareTeamScreenQuery, ManageCareTeamScreenQueryVariables>(ManageCareTeamScreenDocument, options);
        }
export type ManageCareTeamScreenQueryHookResult = ReturnType<typeof useManageCareTeamScreenQuery>;
export type ManageCareTeamScreenLazyQueryHookResult = ReturnType<typeof useManageCareTeamScreenLazyQuery>;
export type ManageCareTeamScreenQueryResult = ApolloReactCommon.QueryResult<ManageCareTeamScreenQuery, ManageCareTeamScreenQueryVariables>;